import DrawerPreviousNext from "components/form/DrawerPreviousNext";
import DrawerCancelNext from "components/form/DrawerCancelNext";
import DrawerPreviousSubmit from "components/form/DrawerPreviousSubmit";
import Error from "components/form/Error";
import SelectSingleCityOnly from "components/form/SelectSingleCityOnly";
import InputArea from "components/form/InputArea";
import LabelArea from "components/form/LabelArea";
import InputAreaPrice from "components/form/InputAreaPrice";
import InputAreaSmall from "components/form/InputAreaSmall";
import Title from "components/form/Title";
import useFixedItinerarySubmit from "hooks/useFixedItinerarySubmit";
import React, { useState } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import ActiveButton from "components/form/ActiveButton";
import DynamicFixedItineraryInput from "components/form/DynamicFixedItinerary";
import DynamicFixedItineraryPrice from "components/form/DynamicFixedItineraryPrice";
import FixedItineraryServices from "services/FixedItineraryServices";
import InputAreaDate from "components/form/InputAreaDate";
import DrawerPreviousCancel from "components/form/DrawerPreviousCancel";
import { notifySuccess } from "utils/toast";
import { Button } from "@windmill/react-ui";
const FixedItineraryDrawer = ({ id, isViewMode }) => {
  const [status, setStatus] = useState(false);
  const [packageCode, setPackageCode] = useState("");
  const {
    trigger,
    register,
    handleSubmit,
    onSubmit,
    handleNextStep,
    handlePreviousStep,
    errors,
    goToStep,
    step,
    selectedCityArrival,
    selectedCityDeparture,
    handleCityChangeArrival,
    handleCityChangeDeparture,
    handleChangesNights,
    handleChangesDays,
    noOfDays,
    noOfNights,
    kmlimit,
    handleCityChange,
    handleChangeInput,
    handleChanges,
    dataInput,
    myPriceRef,
    setSelectedOptions,
    selectedOptions,
    handleVehicleCategoryChange,
    setDataInputPrice,
    dataInputPrice,
    handleChangeInputPrice,
    setDataInput,
    startDate,
    endDate,
    setEndDate,
    handleStartDateChange,
    handleCityChangeNameArrival,
    selectedCityNameArrival,
    handleCityChangeNameDeparture,
    selectedCityNameDeparture,
    loading,
    setValue,
    getValues,
    setError,
    clearErrors,
    primeAvailable,
  } = useFixedItinerarySubmit(id, setStatus, setPackageCode, packageCode);

  const handleCheck = async () => {
    const packagesCode = getValues("package_code");
    if (Number(packagesCode) > 1000) {
      setError("package_code", {
        type: "manual",
        message: "Can't be more than 1000",
      });
    } else {
      clearErrors("package_code");
    }
    if (
      packagesCode !== "" &&
      packagesCode !== undefined &&
      packagesCode !== null &&
      packagesCode !== "undefined" &&
      Number(packagesCode) <= 1000
    ) {
      const res = await FixedItineraryServices.checkPackage({
        package_code: "BT0K" + packagesCode,
      });
      if (res.status) {
        setStatus(true);
        setPackageCode(res.package_code);
      }
      notifySuccess(res.message);
    }
  };

  return (
    <>
      <div className="w-full relative pt-6 pb-3 px-6  border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
        {isViewMode ? (
          <>
            <Title title={"View Fixed Itinerary"} />
          </>
        ) : (
          <>
            {id ? (
              <Title title={"Edit Fixed Itinerary"} />
            ) : (
              <Title title={"Add Fixed Itinerary"} />
            )}
          </>
        )}
      </div>
      <div className="text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-400">
        <ul className="flex flex-wrap -mb-px">
          <li className="mr-2">
            <ActiveButton
              tabValue={1}
              labelName="Route"
              goToStep={goToStep}
              step={step}
            />
          </li>

          {status || id ? (
            <>
              <li className="mr-2">
                <ActiveButton
                  tabValue={2}
                  labelName="Itinerary"
                  goToStep={goToStep}
                  step={step}
                />
              </li>

              <li className="mr-2">
                <ActiveButton
                  tabValue={3}
                  labelName="Vehicle Price"
                  goToStep={goToStep}
                  step={step}
                />
              </li>
            </>
          ) : null}
        </ul>
      </div>

      <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="px-6 pt-8 scrollbar-hide flex-grow w-full h-full max-h-full pb-10">
            {step === 1 && (
              <>
                <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6 items-center">
                  <span style={{ fontWeight: "700" }} class="col-span-2">
                    <LabelArea label={"Package Code"} />
                  </span>
                  {id ? (
                    <>
                      <p>{packageCode}</p>
                    </>
                  ) : (
                    <div className="col-span-8 sm:col-span-4 flex items-center space-x-2">
                      <span>BT0K</span>
                      <span style={{ maxWidth: "200px" }}>
                        <InputAreaPrice
                          trigger={trigger}
                          register={register}
                          label="Package Code"
                          name="package_code"
                          type="text"
                          disabled={status ? true : false}
                          maxLength={5}
                          placeholder={"1234"}
                        />
                      </span>
                      {!status && (
                        <Button onClick={() => handleCheck()}>Check</Button>
                      )}
                      <div
                        className="flex items-center"
                        style={{ width: "250px" }}
                      >
                        <Error errorName={errors.package_code} />
                      </div>
                    </div>
                  )}
                </div>
                {status || id ? (
                  <>
                    <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6 items-center">
                      <span class="col-span-2">
                        <LabelArea label={"Route"} />
                      </span>
                      <div className="col-span-8 sm:col-span-4">
                        <InputArea
                          trigger={trigger}
                          register={register}
                          label="Route"
                          name="route"
                          type="text"
                          readOnly={isViewMode}
                          placeholder={
                            "Mangaore -2N Coorg -2N Wayanad- Calicut"
                          }
                        />
                        <Error errorName={errors.route} />
                      </div>

                      <span class="col-span-2">
                        <LabelArea label={"Kilometer"} />
                      </span>
                      <div className="col-span-8 sm:col-span-4">
                        <InputAreaPrice
                          trigger={trigger}
                          register={register}
                          label="Kilometer"
                          name="kilometer_limit"
                          type="text"
                          value={kmlimit}
                          required={true}
                          maxLength={5}
                          readOnly={isViewMode}
                          placeholder={"1300"}
                          onChangeFunction={(e) =>
                            handleChanges(e.target.value)
                          }
                        />
                        <Error errorName={errors.kilometer_limit} />
                      </div>

                      <span class="col-span-2">
                        <LabelArea label={"Arrival City"} />
                      </span>

                      <div className="col-span-8 sm:col-span-4">
                        <SelectSingleCityOnly
                          register={register}
                          label="Arrival"
                          name="arrival"
                          type="text"
                          readonly={isViewMode}
                          placeholder={"--Choose--"}
                          selectedCity={selectedCityArrival}
                          handleCityChange={handleCityChangeArrival}
                          handleCityChangeName={handleCityChangeNameArrival}
                        />
                        <Error errorName={errors.arrival} />
                      </div>

                      <span class="col-span-2">
                        <LabelArea label={"Departure City"} />
                      </span>

                      <div className="col-span-8 sm:col-span-4">
                        <SelectSingleCityOnly
                          register={register}
                          label="Departure"
                          name="departure"
                          readonly={isViewMode}
                          type="text"
                          placeholder={"--Choose--"}
                          selectedCity={selectedCityDeparture}
                          handleCityChange={handleCityChangeDeparture}
                          handleCityChangeName={handleCityChangeNameDeparture}
                        />
                        <Error errorName={errors.departure} />
                      </div>

                      <span class="col-span-2">
                        <LabelArea label={"No of Nights / Days"} />
                      </span>
                      <div className="col-span-1">
                        <InputAreaSmall
                          trigger={trigger}
                          register={register}
                          label="No of Nights"
                          name="no_of_nights"
                          type="text"
                          readOnly={isViewMode}
                          value={noOfNights}
                          maxLength={2}
                          placeholder={"Nights"}
                          onChangeFunction={(e) => {
                            handleChangesNights(e.target.value);
                            handleChangesDays(Number(e.target.value) + 1);
                          }}
                        />
                        <Error errorName={errors.no_of_nights} />
                      </div>

                      <div className="text-center mt-3 w-28">/</div>

                      <div className="col-span-1">
                        <InputAreaSmall
                          trigger={trigger}
                          register={register}
                          label="No of Days"
                          name="no_of_days"
                          type="text"
                          readOnly={true}
                          value={noOfDays}
                          myPriceRef={myPriceRef}
                          placeholder={"Days"}
                          // onChangeFunction={(e) => handleChangesDays(e.target.value)}
                        />
                        <Error errorName={errors.no_of_days} />
                      </div>
                    </div>
                  </>
                ) : null}

                {status || id ? (
                  <DrawerCancelNext handleNextStep={handleNextStep} />
                ) : null}
              </>
            )}
            {step === 2 && (
              <>
                <div className="grid grid-cols-8 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
                  <DynamicFixedItineraryInput
                    register={register}
                    trigger={trigger}
                    errors={errors}
                    readOnly={isViewMode}
                    setValue={setValue}
                    dataInput={dataInput}
                    setDataInput={setDataInput}
                    handleChange={handleChangeInput}
                    handleCityChange={handleCityChange}
                    arrivalcity={selectedCityArrival}
                    departurecity={selectedCityDeparture}
                    selectedCityNameArrival={selectedCityNameArrival}
                    selectedCityNameDeparture={selectedCityNameDeparture}
                  />
                </div>
                <DrawerPreviousNext
                  handleNextStep={handleNextStep}
                  handlePreviousStep={handlePreviousStep}
                />
              </>
            )}
            {step === 3 && (
              <>
                <div className="grid xl:grid-cols-2 lg:grid-cols-2 gap-5 mb-3">
                  <div className="grid gap-5 mb-3 mt-2">
                    <div className="col-span-1 lg:col-span-4">
                      <LabelArea label="Start Date" />
                    </div>
                    <div className="col-span-1 lg:col-span-8">
                      <InputAreaDate
                        trigger={trigger}
                        register={register}
                        label="Start Date"
                        name="start_date"
                        type="date"
                        readOnly={isViewMode}
                        value={startDate}
                        onChange={handleStartDateChange}
                        min={new Date()}
                      />
                      <Error errorName={errors.start_date} />
                    </div>
                  </div>

                  <div className="grid  gap-5 mb-3 mt-2">
                    <div className="col-span-1 lg:col-span-4 ">
                      <LabelArea label="End Date" />
                    </div>
                    <div className="col-span-1 lg:col-span-8">
                      <InputAreaDate
                        trigger={trigger}
                        register={register}
                        label="End Date"
                        name="end_date"
                        type="date"
                        readOnly={isViewMode}
                        value={endDate}
                        placeholder="dd/mm/yyyy"
                        onChange={(event) => setEndDate(event)}
                        min={
                          startDate
                            ? startDate < new Date()
                              ? new Date()
                              : startDate
                            : new Date()
                        }
                      />
                      <Error errorName={errors.end_date} />
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-8 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
                  <DynamicFixedItineraryPrice
                    register={register}
                    trigger={trigger}
                    errors={errors}
                    readOnly={isViewMode}
                    dataInput={dataInputPrice}
                    primeAvailable={primeAvailable}
                    setDataInput={setDataInputPrice}
                    handleChange={handleChangeInputPrice}
                    selectedOptions={selectedOptions}
                    setSelectedOptions={setSelectedOptions}
                    handleVehicleCategoryChange={handleVehicleCategoryChange}
                  />
                </div>
                {isViewMode ? (
                  <DrawerPreviousCancel
                    handlePreviousStep={handlePreviousStep}
                  />
                ) : (
                  <DrawerPreviousSubmit
                    isSubmitting={loading}
                    handleNextStep={handleNextStep}
                    handlePreviousStep={handlePreviousStep}
                  />
                )}
              </>
            )}
          </div>
        </form>
      </Scrollbars>
    </>
  );
};

export default FixedItineraryDrawer;
